import * as React from "react";
import PropTypes from 'prop-types';

const SvgRewardsImportPoint = props => {
  if (props.id !== "_svgrewardsimportpoint") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 48 48" fill="none" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M24 4.8c10.604 0 19.2 8.597 19.2 19.2S34.605 43.2 24 43.2C13.399 43.2 4.8 34.603 4.8 24S13.399 4.8 24 4.8zm1.455 8.618h-2.344l.088 2.246c-2.46.41-4.395 2.11-4.395 4.69 0 2.227 1.376 3.515 3.632 4.57l1.526.674c1.874.85 2.99 1.466 2.99 2.815 0 1.259-.88 2.225-2.99 2.225-2.022 0-3.635-.995-4.425-1.728l-1.583 2.14c.733.644 2.285 1.699 4.924 1.905l-.03 1.627h2.343l-.088-1.715c3.107-.469 4.602-2.55 4.602-4.718 0-2.434-1.552-3.517-4.015-4.602l-1.32-.585c-1.699-.762-2.81-1.466-2.81-2.844 0-1.318.994-2.139 2.753-2.139 1.32 0 2.579.557 3.34 1.26l1.642-2.08c-.557-.498-1.846-1.348-3.84-1.554v-2.188z" fill="#E71324" /></svg>;
};

SvgRewardsImportPoint.displayName = "_svgrewardsimportpoint";
SvgRewardsImportPoint.propTypes = {
  id: PropTypes.string
};
SvgRewardsImportPoint.defaultProps = {
  id: ''
};
export default SvgRewardsImportPoint;